import { render } from "./ServiceSituation.vue?vue&type=template&id=746dfe64&scoped=true"
import script from "./ServiceSituation.vue?vue&type=script&lang=js"
export * from "./ServiceSituation.vue?vue&type=script&lang=js"

import "./ServiceSituation.vue?vue&type=style&index=0&id=746dfe64&lang=scss&scoped=true"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746dfe64"]])

export default __exports__